import APIError from '../APIError';

class RentReleaseSummaryError extends APIError {
  constructor(code, details = null) {
    super(code, 'RentReleaseSummaryError', details);
  }
}

export default RentReleaseSummaryError;
